// TODO: Migrate to V2
import {
  Button,
  Card,
  Text,
} from '../../../deprecated-components/BaseComponents'
import { Icon } from '@/ui'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { faEdit } from '@fortawesome/pro-regular-svg-icons'
import styles from './styles.module.scss'

interface ReviewStep {
  name: string
  route: string
}

interface ReviewStepCardProps {
  step: ReviewStep
  setReviewIndex: (index: string) => void
  pendingText?: string
  showErrorState?: boolean
  isPending?: boolean
}

const PendingStepCard = ({
  step,
  setReviewIndex,
  pendingText,
  showErrorState,
}: {
  step: ReviewStep
  setReviewIndex: (index: string) => void
  pendingText?: string
  showErrorState?: boolean
}) => {
  return (
    <Card backgroundColor="lightRed" fullWidth padding={24}>
      <div className={styles.cardLayout}>
        <div className={styles.cardContent}>
          <Text as="h3" className={styles.cardTitle}>
            {step.name}
          </Text>
          {pendingText && (
            <Text className={styles.cardDescription}>{pendingText}</Text>
          )}
          {showErrorState && (
            <Text className={styles.cardErrorText}>
              To send updates, please go to step and complete the requested
              updates.
            </Text>
          )}
        </div>
        <Button variant="secondary" onClick={() => setReviewIndex(step.route)}>
          Go to Step →
        </Button>
      </div>
    </Card>
  )
}

const CompleteStepCard = ({
  step,
  setReviewIndex,
}: {
  step: ReviewStep
  setReviewIndex: (index: string) => void
}) => {
  return (
    <Card backgroundColor="stone40" fullWidth padding={24}>
      <div className={styles.cardLayout}>
        <Button
          variant="link"
          onClick={() => setReviewIndex(step.route)}
          className={styles.completeStepButton}
        >
          <div className={styles.completeStepButtonContent}>
            <Icon
              icon={faCheck}
              color="green"
              size="lg"
              className={styles.iconNoShrink}
            />
            <Text as="h3" className={`${styles.cardTitle} ${styles.titleFlex}`}>
              {step.name}
            </Text>
            <Icon
              icon={faEdit}
              color="text-neutral-600"
              size="sm"
              className={styles.iconRight}
            />
          </div>
        </Button>
      </div>
    </Card>
  )
}

export const ReviewStepCard = ({
  step,
  setReviewIndex,
  pendingText = '',
  showErrorState = false,
  isPending = true,
}: ReviewStepCardProps) => {
  if (isPending) {
    return (
      <PendingStepCard
        step={step}
        setReviewIndex={setReviewIndex}
        pendingText={pendingText}
        showErrorState={showErrorState}
      />
    )
  }

  return <CompleteStepCard step={step} setReviewIndex={setReviewIndex} />
}
